import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import MenuBar from './common/MenuBar';
import { DataGrid } from '@mui/x-data-grid';
import CircularProgress from '@mui/material/CircularProgress';
import { loadRxDetails, getAttachmentPath, loadMemberConcern,getWinCardUrl, getOpenOrdersFile } from '../Services/loadOrder';
import Box from '@mui/material/Box';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import '../assets/css/home.css';
import { Toaster, toast } from 'react-hot-toast';

const PaidTaskOpenOrders = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { taskId, contract, pharmacyId, userId, rxData } = location.state || {};

  const [taskDetail, setTaskDetail] = useState(null);
  const [sourceData, setSourceData] = useState(null);
  const [gridRows, setGridRows] = useState([]);
  const [totalAmount, setTotalAmount] = useState('0.00');
  const [shippingCarrier, setShippingCarrier] = useState('');
  const [trackingNumber, setTrackingNumber] = useState('');
  const [Prescriptions, setPrescriptions] = useState([]);
   const [shipping, setShipping] = useState({});
   const [notes, setNotes] = useState('');
   const [documents, setDocuments] = useState([]);
   const [attachmentUrls, setAttachmentUrls] = useState([]);
   const [notesBoxActive, setNotesBoxActive] = useState(false);
   const [mainGridRows, setMainGridRows] = useState([]);
           const [menopurGridRows, setMenopurGridRows] = useState([]);
           const [memberConcernFlag, setMemberConcernFlag] = useState(false);
           const [memberConsent, setMemberConsent] = useState(false);
           const [winCardAmount, setWinCardAmount] = useState('0.00');
           const [TotalMemberPays, setTotalMemberPays] = useState('0.00');
           const [totalWinPays, setTotalWinPays] = useState('0.00');
           const [contractType, setContractType] = useState('');
           const [showMemberWinCard, setShowMemberWinCard] = useState(false);

//   const [modalOpen, setModalOpen] = useState(false);
//   const [modalMessage, setModalMessage] = useState('');
//   const [shouldRedirect, setShouldRedirect] = useState(false);
//   const [pendingRollbackInfo, setPendingRollbackInfo] = useState(null);
//   const [isSubmitting, setIsSubmitting] = useState(false);

   useEffect(() => {
      const fetchRx = async () => {
        try {
          const result = await loadRxDetails(taskId, contract, pharmacyId, userId);
          const data = result?.data || {};
  
          const task = data.TaskDetail?.[0] || {};
          const task2 = data.TaskDetail?.[1] || {};
          const shippingInfo = data.ShippingInfos?.[0] || {};
          const prescriptions = data.Prescriptions || [];
          const document = data.Documents || [];
          console.log("this is the document array", document);
          console.log("prescriptions data:------@", prescriptions);
  
          if (result.success) {
          
            let memberConcern;
            if (task.ContractType === 'Premier') {
          memberConcern = await loadMemberConcern(taskId, contract);
          console.log("Member Concern Data:", memberConcern);
  
          if (memberConcern.data) {
            if (memberConcern.data.Flag === 'Y') {
              setMemberConcernFlag(true);
            }
            if (memberConcern.data.MemberConsent === 'Y') {
              setShowMemberWinCard(true);
            }
          }
        }
        
  
          const fetchUrls = async () => {
                const urls = await Promise.all(
                  document.map(doc => getAttachmentPath(doc.Path))
                );
                console.log("Fetched attachment URLs:", urls);
                setAttachmentUrls(urls);}
                fetchUrls();
  
          setSourceData(data);      
          setTaskDetail(task);
          //setTaskDetail2(task2);
          setShipping(shippingInfo);
          setShippingCarrier(shippingInfo.ShippingCarrier || '');
          setTrackingNumber(shippingInfo.TrackingNo || '');
          setPrescriptions(prescriptions);
          setDocuments(document);
          setContractType(task?.ContractType || '');
  
          if ((memberConcern && memberConcern.data.Flag === 'Y') && task?.ContractType === 'Premier') {
          
                    //  const rebateFlag = await loadRebateValidationFlag( contract,
                    //           task?.MemberID, pharmacyId, userId );
                    //         setRebateValidationFlag(rebateFlag?.Validation === 'Y' ? 'Y' : 'N');
                    
                            // Use details.Prescriptions for initial grid setup
                      const Prescriptions = prescriptions;
                      const contractType = task?.ContractType;
                      const pharmacyID = task?.PharmacyID || pharmacyId;
                      console.log("Prescription data for menopurcase:::::::", Prescriptions);
                    
                      console.log("Contract Type:", contractType);
                    
                      // Split prescriptions into Menopur and others
                      const menopurRows = Prescriptions.filter(p => p.DrugName?.toUpperCase().includes('MENOPUR'));
                      const otherRows = Prescriptions.filter(p => !p.DrugName?.toUpperCase().includes('MENOPUR'));
                    
                      console.log("Menopur Rows:-------$", menopurRows);
                      console.log("Other Rows:------$", otherRows);
                      const mainRows = otherRows.map((p) => ({
                        id: p.PresID ,
                        Effdt: p.MedStartDate || '',
                        NDC: p.NDC || '',
                        DrugName: p.DrugName || '',
                        GPIName: p.GPIName || '',
                        AppQty: p.AppQty ?? '',
                        Units: p.Units ?? '',
                        DispQty: p?.['Disp Qty'] ?? '',
                        CancelQty: p?.['Cancel Qty'] ?? '',
                        Reason: p.Reason || '',
                        ['Member Pays']: parseFloat(p?.['Member Pays'] || 0).toFixed(2),
                        ['Reimbursment Amount']: parseFloat(p?.['Reimbursment Amount'] || 0).toFixed(2),
                      }));
                      const menopurRowsGrid = menopurRows.map((p) => ({
                        id: p.PresID ,
                        Effdt: p.MedStartDate || '',
                        NDC: p.NDC || '',
                        DrugName: p.DrugName || '',
                        GPIName: p.GPIName || '',
                        AppQty: p.AppQty ?? '',
                        Units: p.Units ?? '',
                        DispQty: p?.['Disp Qty'] ?? '',
                        CancelQty: p?.['Cancel Qty'] ?? '',
                        Reason: p.Reason || '',
                        ['Member Pays']: parseFloat(p?.['Member Pays'] || 0).toFixed(2),
                        ['Reimbursment Amount']: parseFloat(p?.['Reimbursment Amount'] || 0).toFixed(2),
                      }));
                    
                      setMenopurGridRows(menopurRowsGrid);
                    
                      setMainGridRows(mainRows);
                    
                      // after setMenopurGridRows(...) and setMainGridRows(...)
                    setGridRows([
                      ...menopurRows.map(pres => ({ ...pres, id: pres.PresID, CancelQty: parseFloat(pres.AppQty||0)-parseFloat(pres.DispQty||0) })),
                      ...otherRows.map(pres   => ({ ...pres, id: pres.PresID, CancelQty: parseFloat(pres.AppQty||0)-parseFloat(pres.DispQty||0) })),
                    ]);
                    
                    
                    return; // keep your early return
                    
                  }
  
          
  
          const rows = prescriptions.map((p, i) => {
            const baseRow = {
              id: p.PresID || i + 1,
              Effdt: p.MedStartDate || '',
              NDC: p.NDC || '',
              DrugName: p.DrugName || '',
              GPIName: p.GPIName || '',
              AppQty: p.AppQty ?? '',
              Units: p.Units ?? '',
              DispQty: p?.['Disp Qty'] ?? '',
              CancelQty: p?.['Cancel Qty'] ?? '',
              Reason: p.Reason || '',
              ['Member Pays']: parseFloat(p?.['Member Pays'] || 0).toFixed(2),
  
            };
  
            if (contract === 'HMO Illinois' || contract === 'WINFertilityRx' || 
              contract === 'WINFertility Genetics' || contract === 'WINFertility DTC') {
              baseRow.Amount = parseFloat(p?.['Reimbursment Amount'] || 0).toFixed(2);
            } else if (task?.ContractType === 'Premier') {
              baseRow['Reimbursment Amount'] = parseFloat(p?.['Reimbursment Amount'] || 0).toFixed(2);
            }
  
            return baseRow;
          });
  
          console.log("Grid Rows: =====>", rows);
          setGridRows(rows);
  
          const total = (contract === 'HMO Illinois'|| contract === 'WINFertilityRx' || 
              contract === 'WINFertility Genetics' || contract === 'WINFertility DTC')
            ? rows.reduce((sum, r) => sum + (parseFloat(r.Amount) || 0), 0)
            : rows.reduce((sum, r) => sum + (parseFloat(r['Reimbursment Amount']) || 0), 0);
  
          setTotalAmount(total.toFixed(2));
  
          }
        } catch (error) {
          console.error('Error loading RX details:', error);
          navigate('/error-page');
        }
      };
  
     
  
      if (taskId && contract && pharmacyId && userId) {
        fetchRx();
      }
    }, [taskId, contract, pharmacyId, userId]);

  useEffect(() => {
      if (!gridRows || (!mainGridRows && !menopurGridRows)) return;
    
      const fetchCostShare = async () => {
    
        let rxCost;
        let totalCostShare;
        let copay;
        let reimbAmountMain;
        let reimbAmountMenopur;
        let memberPaysMenopur;
        let memberPaysMain;
        let winCardAmount;
    
        
    
        if (memberConcernFlag === true) {
          reimbAmountMain = mainGridRows.reduce((sum, row) => sum + (parseFloat(row['Reimbursment Amount'] || 0)), 0);
          reimbAmountMenopur = menopurGridRows.reduce((sum, row) => sum + (parseFloat(row['Reimbursment Amount'] || 0)), 0);
          memberPaysMenopur = menopurGridRows.reduce((sum, row) => sum + (parseFloat(row['Member Pays']  || 0)), 0);
          memberPaysMain = mainGridRows.reduce((sum, row) => sum + (parseFloat(row['Member Pays']  || 0)), 0);
          winCardAmount = reimbAmountMenopur - memberPaysMenopur;
          copay = parseFloat(memberPaysMain + memberPaysMenopur).toFixed(2);
          rxCost = parseFloat(reimbAmountMain + reimbAmountMenopur).toFixed(2);
          totalCostShare = parseFloat(memberPaysMain + memberPaysMenopur).toFixed(2);
          //(rxCost - menopurTotal - totalCostShare) + menopurCostShare
          console.log("This is the copay: =====>", copay);
          console.log("This is the reimbusrement Amount: =====>", reimbAmountMain + reimbAmountMenopur);
          console.log("This is the winCardAmount: =====>", winCardAmount);
          setTotalMemberPays(copay || '0.00');
          setTotalWinPays( (rxCost - reimbAmountMenopur - totalCostShare + memberPaysMenopur) || '0.00');
          setWinCardAmount(winCardAmount.toFixed(2) || '0.00');
          
    
        } else {
          copay = gridRows.reduce((sum, row) => sum + (parseFloat(row['Member Pays']  || 0)), 0);
          reimbAmountMain = gridRows.reduce((sum, row) => sum + (parseFloat(row['Reimbursment Amount'] || 0)), 0);
          
          console.log("This is the copay: =====>", copay);
          console.log("This is the reimbusrement Amount: =====>", reimbAmountMain);
          setTotalMemberPays(copay.toFixed(2) || '0.00');
          setTotalWinPays(parseFloat(reimbAmountMain - copay).toFixed(2) || '0.00');
        }
    
        //setTotalMemberPays(offerAmount || '0.00');
    
      };
      fetchCostShare();
    }, [taskDetail, gridRows]);

  // document mapping

  const document = documents || [];

    const documentArray = document.map((doc, index) => ({

      id: index,
      documentList: doc.Path,
      bytes: doc.PDFDocument,
    })
  
  )

  const documentArraylength = documentArray.length;

  const handleFileDisplay = async (file, bytes) => {
    if (!file) return;
  
    let fileName = typeof file === 'string' ? file : file.name;
    const ext = fileName.slice(fileName.lastIndexOf('.')).toLowerCase();
    const docType = 'Prescription';
    const memberID = Array.isArray(taskDetail) ? taskDetail[0]?.MemberID : taskDetail?.MemberID;
  
    const base64 = bytes;
  
    
      try {
        const response = await getOpenOrdersFile(memberID, fileName, contract, docType, base64); // Pass null or omit base64
        if (response) {
          window.open(response, '_blank', 'noopener,noreferrer');
        }
      } catch (error) {
        console.error("Error fetching file:", error);
        toast.error('Failed to fetch file');
      }
      return ;
    
  };

  console.log("Document Array:", {documentArray, documentArraylength});

  const columns = [
    { field: 'Effdt', headerName: 'Med Start Date', width: 100, headerClassName: 'pink-header', sortable: false },
    { field: 'NDC', headerName: 'NDC', width: 150, headerClassName: 'pink-header', sortable: false },
    { field: 'DrugName', headerName: 'Drug Name', width: 200, headerClassName: 'pink-header', sortable: false,
      renderCell: (params) => (
    <div
      style={{
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        lineHeight: 1.3,
        padding: '10px 2px',
        width: '100%',
      }}
    >
      {params.value}
    </div>
  ),
     },
    { field: 'GPIName', headerName: 'GPI Name', width: 200, headerClassName: 'pink-header', sortable: false, 
      renderCell: (params) => (
    <div
      style={{
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        lineHeight: 1.3,
        padding: '10px 2px',
        width: '100%',
      }}
    >
      {params.value}
    </div>
  ),
     },
    { field: 'AppQty', headerName: 'App Qty', width: 80, headerClassName: 'pink-header', sortable: false },
    { field: 'Units', headerName: 'Units', width: 80, headerClassName: 'pink-header', sortable: false },
    { field: 'DispQty', headerName: 'Disp Qty', width: 100, headerClassName: 'pink-header', sortable: false },
    { field: 'CancelQty', headerName: 'Cancel Qty', width: 100, headerClassName: 'pink-header', sortable: false },
    { field: 'Reason', headerName: 'Reason', width: 150, headerClassName: 'pink-header', sortable: false },
  ];

  if (contract === 'HMO Illinois') {
    columns.push({ field: 'Amount', headerName: 'Amount', width: 150, headerClassName: 'pink-header', sortable: false });
  } else if (taskDetail?.ContractType === 'Premier') {
    columns.push({ field: 'Reimbursment Amount', headerName: 'Reimbursment Amount', width: 150, headerClassName: 'pink-header', sortable: false });
  }

  const winCardCol = {
        field: 'WinCard',
        headerName: 'WinCard',
        width: 140,
        sortable: false,
        headerClassName: 'pink-header',
        renderCell: (params) => {
          if (!params.row.DrugName?.toUpperCase().includes('MENOPUR') || params.row.isSummary) return null;
      
          if (showMemberWinCard){
          return (
            <button
              style={{
                padding: '4px 12px',
                borderRadius: '8px',
                background: '#ec008c',
                color: '#fff',
                border: 'none',
                cursor: 'pointer',
                fontSize: '13px'
              }}
              onClick={async () => {
                const info = {
                  PresID: params.row.PresID,
                  MemberID: params.row.MemberID,
                  // ...add other required fields if needed
                };
                const winCardLink = await getWinCardUrl(info);
                if (winCardLink) {
                  window.open(winCardLink, '_blank'); // Open the URL in a new tab
                } else {
                  toast.error("Win Card link not available.");
                }
              }}
            >
              View WinCard
            </button>
          );
        } else if (!showMemberWinCard) {
          return (
            <span style={{ color: 'gray',  fontSize: '12px' }}>
              View WinCard
            </span>
          );
      
        }
        }
      }
      //  Menopur grid columns: start from main and then add WINCard when that scenario applies
      const showWinCard =
        (memberConcernFlag === true ) &&
        (contractType=== 'Premier' || contractType === 'Premier');
      
      const columnsMenopur = showWinCard ? [...columns, winCardCol] : columns;

  //summary row for total amount
  const totalReimbursement = Prescriptions.reduce((sum, row) => {
        return sum + parseFloat(row?.['Reimbursment Amount'] || 0);
      }, 0);

    const totalMainReimbAmount = mainGridRows.reduce((sum, row) => {
        return sum + parseFloat(row?.['Reimbursment Amount'] || 0);
      }, 0);

    const totalMenopurReimbAmount = menopurGridRows.reduce((sum, row) => {
        return sum + parseFloat(row?.['Reimbursment Amount'] || 0);
      }, 0);

  //summary row for total amount
  let summaryRow = {}; 
let summaryRowMainGrid = {};
   let summaryRowMenopurGrid = {};  
    
  console.log("Task Detail::::::::", sourceData);

  if (!sourceData) {
   return (
    <div>
      <MenuBar />
      <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
        <CircularProgress sx={{ color: '#ec008c' }} />
        <span style={{ marginTop: '16px', color: '#ec008c', fontSize: '16px', fontWeight: 500 }}>
          Your request is being processed...
        </span>
      </Box>
    </div>
  );
  }

   if (taskDetail?.ContractType?.trim() === 'Premier' && memberConcernFlag === true) {
    summaryRowMainGrid = {
  id: 'summary-row',
  'Reimbursment Amount': Number(totalMainReimbAmount).toFixed(2),
};

summaryRowMenopurGrid = {
  id: 'summary-row',
  'Reimbursment Amount': Number(totalMenopurReimbAmount).toFixed(2),
};
   } else {

summaryRow = {
  id: 'summary-row',
  'Reimbursment Amount': Number(totalReimbursement).toFixed(2),
  // All other fields left blank
};
}



  const rowsWithSummary = [...gridRows, summaryRow];
  const mainGridRowsWithSummary = [...mainGridRows, summaryRowMainGrid];
  const menopurGridRowsWithSummary = [...menopurGridRows, summaryRowMenopurGrid];

  return (
    <>
    <div>
      <Toaster position="top-right" />
      
        <MenuBar />
        <div className='top-page-option'>
          <div className='top-page-option-name' style={{ display: 'flex', alignItems: 'center' }}>
            <a href="#/paid-claims" style={{ textDecoration: 'none', color: '#ec088c', display: 'inline-flex', alignItems: 'center' }}>
              <ChevronLeft color='#ec088c' size={18} />
              <span style={{ marginLeft: '5px' }}>Back</span>
            </a>
          </div>
          <div className='top-page-option-name' style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                  <span>Dispensed Orders</span>
                                                  <ChevronRight color='#ec088c' size={18} style={{ position: 'relative', top: '2px' }} />
                                                  <span>Paid Claims</span>
                                                  <ChevronRight color='#ec088c' size={18} style={{ position: 'relative', top: '2px' }}/>
                                                  <span>Claims Info</span>
                                                </div>
        </div>
         <div className="outer-box" style={{
          background: '#fff',
          padding: '0px',
          borderRadius: '10px',
          marginLeft: '100px',
          marginRight: '100px',
          textAlign: 'left', // force left alignment for all children
          alignItems: 'flex-start', // ensure children align left
          display: 'block' // remove any flex centering
        }}> 


        {/* Member Info */}
        <div className="open-order-box" style={{fontFamily: 'segoe ui', textAlign: 'left', alignItems: 'flex-start', display: 'block' }}>

        <div className="sub-section-header" style={{color: '#ec008c', fontWeight: 'bold', marginBottom: '-5px',marginLeft:'25px', fontSize: '18px' }}>Member Info</div>
<br style={{ display: 'none' }} />
<div className="details-grid" style={{
  display: 'grid',
  gridTemplateColumns: 'repeat(4, 1fr)',
  gap: '18px 32px',
  borderRadius: '10px',
  padding: '18px 24px',
  marginBottom: '-30px',
  alignItems: 'start',
  fontSize: '14px',
  color: '#222',
  fontFamily: 'segoe ui',
  textAlign: 'left',
  justifyItems: 'start',
  width: 'fit-content',
  marginLeft: 0
}}>
  <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
    <strong style={{ color: 'Black', fontSize: '14px', minWidth: '140px', display: 'inline-block', flexShrink: 0 }}>Member ID:</strong>
    <span style={{ fontSize: '14px', marginLeft: '-50px', wordBreak: 'break-all', flex: 1 }}>{taskDetail.MemberID}</span>
  </div>
  <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
    <strong style={{ color: 'Black', fontSize: '14px', minWidth: '130px', display: 'inline-block', flexShrink: 0 }}>Name:</strong>
    <span style={{ fontSize: '14px', marginLeft: '-50px', wordBreak: 'break-all', flex: 1 }}>{taskDetail.MemberName}</span>
  </div>
  <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
    <strong style={{ color: 'Black', fontSize: '14px', minWidth: '130px', display: 'inline-block', flexShrink: 0 }}>DOB:</strong>
    <span style={{ fontSize: '14px', marginLeft: '-50px', wordBreak: 'break-all', flex: 1 }}>{taskDetail.DOB ? new Date(taskDetail.DOB).toLocaleDateString() : ''}</span>
  </div>
  <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
    <strong style={{ color: 'Black', fontSize: '14px', minWidth: '150px', display: 'inline-block', flexShrink: 0 }}>RelationShip:</strong>
    <span style={{ fontSize: '14px', marginLeft: '-50px', wordBreak: 'break-all', flex: 1 }}>{taskDetail.RelationShip || 'N/A'}</span>
  </div>
  <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
    <strong style={{ color: 'Black', fontSize: '14px', minWidth: '130px', display: 'inline-block', flexShrink: 0 }}>Phone:</strong>
    <span style={{ fontSize: '14px', marginLeft: '-50px', wordBreak: 'break-all', flex: 1 }}>{taskDetail.CellPhone}</span>
  </div>
  <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
    <strong style={{ color: 'Black', fontSize: '14px', minWidth: '130px', display: 'inline-block', flexShrink: 0 }}>Email ID:</strong>
    <span style={{ fontSize: '14px', marginLeft: '-50px', wordBreak: 'break-all', flex: 1 }}>{taskDetail.EmailID}</span>
  </div>
  <div style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
    <strong style={{ color: 'Black', fontSize: '14px', minWidth: '150px', display: 'inline-block', flexShrink: 0 }}>Certified For:</strong>
    <span style={{ fontSize: '14px', marginLeft: '-50px', wordBreak: 'break-all', flex: 1 }}>{taskDetail.CertifiedFor}</span>
  </div>
  
</div><br/>





<div style={{ margin: '20px 0', width: '100%', paddingLeft: '20px' }}>
  <table style={{ borderCollapse: 'collapse', width: '100%', fontSize: '14px', tableLayout: 'fixed', fontFamily: 'segoe ui' }}>
    <colgroup>
      <col style={{ width: '33.33%' }} />
      <col style={{ width: '33.33%' }} />
      <col style={{ width: '33.33%' }} />
    </colgroup>
    <thead>
      <tr>
        <th style={{ borderLeft: 'none', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '6px', color: '#ec008c', fontWeight: 'bold', fontSize: '18px', fontFamily: 'segoe ui', textAlign: 'left' }}>Provider Info</th>
        <th style={{ borderLeft: '1px solid #ec008c', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '6px', color: '#ec008c', fontWeight: 'bold', fontSize: '18px', fontFamily: 'segoe ui', textAlign: 'left' }}>Authorization Info</th>
        <th style={{ borderLeft: '1px solid #ec008c', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '6px', color: '#ec008c', fontWeight: 'bold', fontSize: '18px', fontFamily: 'segoe ui', textAlign: 'left' }}>Attachments</th>
      </tr>
    </thead>
    <tbody style={{ fontFamily: 'segoe ui' }}>
      <tr style={{ fontFamily: 'segoe ui', height: '38px' }}>
        <td style={{ borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '6px', verticalAlign: 'top', wordBreak: 'break-word', fontFamily: 'segoe ui' }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '14px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Provider Name:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{taskDetail.SerProName}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '14px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Provider Phone:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{taskDetail.Telephone}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <strong style={{ fontSize: '14px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Provider Fax:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{taskDetail.Fax}</span>
          </div>
        </td>
        <td style={{ borderLeft: '1px solid #ec008c', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '6px', verticalAlign: 'top', wordBreak: 'break-word', fontFamily: 'segoe ui' }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '14px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>WIN Auth #:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{taskDetail.AuthNo}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '14px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Auth Duration:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{taskDetail?.['Auth Duration']}</span>
          </div>
          {/* <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '14px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Contract:</strong>
            <span style={{ fontSize: '13px', marginLeft: '8px' }}>{rxData[0]?.Contract}</span>
          </div> */}
        </td>
        <td style={{ borderLeft: '1px solid #ec008c', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '6px', verticalAlign: 'top', wordBreak: 'break-word', fontFamily: 'segoe ui' }}>
          {documentArray.length > 0 && (
            <div className="attachment-box" style={{ flex: "0 1 300px", textAlign: 'left', paddingTop: '-20px', fontFamily: 'segoe ui',marginTop:'-14px' }}>
              {documentArray.map((doc, index) => {
      const fileUrl = doc.documentList.replaceAll('\\', '/').replaceAll('\\\\', '/');
      const fileName = fileUrl.split('/').pop();
      // const downloadUrl = attachmentUrls[index]; // Not needed for handleFileDisplay
      return (
        <button
          key={doc.id}
          type="button"
          className="attachment-link"
          style={{
            color: 'blue',
            display: 'flex',
            alignItems: 'center',
            marginTop: '10px',
            fontFamily: 'segoe ui',
            fontSize: '14px',
            textDecoration: 'none',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: 0,
          }}
          onClick={() => handleFileDisplay(doc.documentList, doc.bytes)} // Pass both path and bytes
        >
          <strong style={{ fontSize: '15px', fontFamily: 'segoe ui', marginRight: '4px', textDecoration: 'none' }}>{`Prescription ${index + 1}:`}</strong>
          <span style={{ fontSize: '14px', fontFamily: 'segoe ui', textDecoration: 'underline' }}>{fileName}</span>
        </button>
      );
    })}
              {/* <p className="attachment-note" style={{ fontStyle: 'italic', marginTop: '10px', fontFamily: 'segoe ui', fontSize: '14px' }}>
                *please see .TIFF attachment for "Other Drugs" in this Rx
              </p> */}
            </div>
          )}
        </td>
      </tr>
    </tbody>
  </table>
  {/* New 2-column table below the existing table, same design */}


  <table style={{ marginTop:'30px',borderCollapse: 'collapse', width: '100%', fontSize: '13px', tableLayout: 'fixed', fontFamily: 'segoe ui',padding: '0 5px' }}>
    <colgroup>
      <col style={{ width: '33.3%' }} />
      <col style={{ width: '66.7%' }} />
    </colgroup>
    <thead>
      <tr>
        <th style={{ borderLeft: 'none', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '5px', color: '#ec008c', fontWeight: 'bold', fontSize: '18px', fontFamily: 'segoe ui', textAlign: 'left' }}>Task Info</th>
        <th style={{ borderLeft: '1px solid #ec008c', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '6px', color: '#ec008c', fontWeight: 'bold', fontSize: '18px', fontFamily: 'segoe ui', textAlign: 'left' }}>Task Notes</th>
      </tr>
    </thead>
    <tbody style={{ fontFamily: 'segoe ui' }}>
      <tr style={{ fontFamily: 'segoe ui', height: '38px' }}>
        <td style={{ fontFamily: 'segoe ui' , padding: '6px', }}>
          
           <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '14px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Assigned by:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{taskDetail.AssignedBy}</span>
          </div>
           <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '14px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Group ID:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{taskDetail.GroupID}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '14px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Priority:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{taskDetail.PriorityStatus}</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '14px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Received:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{taskDetail.ReceivedDate}</span>
          </div>
		   <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
            <strong style={{ fontSize: '14px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Med Start Date:</strong>
            <span style={{ fontSize: '14px', marginLeft: '8px' }}>{taskDetail.SchStartDate}</span>
          </div>
         </td>
      <td style={{ borderLeft: '1px solid #ec008c', borderRight: 'none', borderTop: 'none', borderBottom: 'none', padding: '6px', verticalAlign: 'top', wordBreak: 'break-word', fontFamily: 'segoe ui' }}>
          <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        alignItems: "flex-start",
        gap: "40px",
        maxWidth: "80%",
      }}
    >
      <div
        className="notes-box"
        style={{
          flex: "1 1 300px",
          position: 'relative',
          boxShadow: notesBoxActive ?  '#ec008c' : undefined,
          borderRadius: '8px',
          padding: '4px',
          transition: 'box-shadow 0.2s',
        }}
        onFocus={(e) => {
        e.target.style.border = '1px solid #ec008c';
        e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
      }}
      onBlur={(e) => {
         e.target.style.border = '1px solid rgba(236, 152, 202)';
        e.target.style.boxShadow = '0 1px 2px rgba(236, 152, 202)';
      }}
        tabIndex={0}
      >
        <textarea
          className="notes-textarea"
          readOnly
          value={taskDetail?.notes || ""}
          style={{
            width: "95%",
            minHeight: "100px",
            padding: "12px",
            fontSize: "13px",
            borderRadius: "25px",
            border: "1px solid rgba(236, 152, 202)",
            resize: "vertical",
            background: 'white',
            outline: 'none',
            color: notesBoxActive ? '#ec008c' : 'black',
            transition: 'color 0.2s',
          }}
          onFocus={(e) => {
        e.target.style.border = '1px solid #ec008c';
        e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
      }}
      onBlur={(e) => {
         e.target.style.border = '1px solid rgba(236, 152, 202)';
        e.target.style.boxShadow = '0 1px 2px rgba(236, 152, 202)';
      }}
        />
      </div>
    </div>
        </td>
      </tr>
    </tbody>
  </table>

 {/* <div
  style={{
    marginTop: '30px',
    borderCollapse: 'collapse',
    width: '100%',
    fontSize: '13px',
    tableLayout: 'fixed',
    fontFamily: 'segoe ui',
    padding: '0 5px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center', // center children horizontally
  }}
>
  <h2 style={{ fontSize: '18px', color: '#ec008c', textAlign: 'center', marginBottom: '12px', fontWeight: 'bold' }}>
    Task Notes
  </h2>
  <textarea
    className="notes-textarea"
    readOnly
    value={notes || ""}
    style={{
      width: "60%",
      minHeight: "100px",
      padding: "12px",
      fontSize: "13px",
      borderRadius: "6px",
      border: "1px solid #ccc",
      resize: "vertical",
      background: 'white',
      outline: 'none',
      color: notesBoxActive ? '#ec008c' : 'black',
      transition: 'color 0.2s',
    }}
    onFocus={(e) => {
      e.target.style.border = '1px solid #ec008c';
      e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
    }}
    onBlur={(e) => {
      e.target.style.border = '1px solid #ccc';
      e.target.style.boxShadow = '0 1px 2px rgba(0,0,0,0.05)';
    }}
  />
</div> */}

</div>
</div>

        {/* Shipping Info */}
        <div className="open-order-box" style={{ fontFamily: 'segoe ui' }}>
                      <div className="sub-section-header" style={{color: '#ec008c', fontWeight: 'bold', fontSize: '18px' }}>Shipping Info</div><br/>
                      <table className='Shpping-Info-table' style={{ margin: '0 auto', width: '60%', tableLayout: 'fixed', borderCollapse: 'collapse' }}>
  <colgroup>
    <col style={{ width: '50%' }} />
    <col style={{ width: '50%' }} />
  </colgroup>
  <tbody>
    <tr>
      <td style={{ fontSize: '14px', textAlign: 'left', verticalAlign: 'middle', padding: '8px', borderRight: '1px solid #ec008c' }}>     
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
          <strong style={{ fontSize: '14px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Phone :</strong>
          <span style={{ fontSize: '14px', marginLeft: '8px' }}>{shipping?.Phone}</span>
        </div>  
      </td>
      <td style={{ textAlign: 'center', verticalAlign: 'middle', padding: '8px' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <strong style={{ fontSize: '14px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Shipping Carrier :</strong>
          <input
            style={{
              width: '30%',
              minHeight: '20px',
              marginLeft: '8px',
              padding: '8px',
              fontSize: '14px',
              borderRadius: '15px',
              border: '1px solid rgba(236, 152, 202)',
              color: '#222',
              fontFamily: 'Segoe UI, Arial, sans-serif',
              outline: 'none',
              boxShadow: '0 1px 4px 0 rgba(236,0,140,0.07)'
              
            }}onFocus={(e) => {
        e.target.style.border = '1px solid #ec008c';
        e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
      }}
      onBlur={(e) => {
         e.target.style.border = '1px solid rgba(236, 152, 202)';
        e.target.style.boxShadow = '0 1px 2px rgba(236, 152, 202)';
      }}value={shippingCarrier}/>
            
           
         
        </div>
      </td>
    </tr>
    <tr>
      <td style={{ textAlign: 'left', verticalAlign: 'middle', padding: '8px', borderRight: '1px solid #ec008c' }}>     
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
          <strong style={{ fontSize: '14px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Fax :</strong>
          <span style={{ fontSize: '14px', marginLeft: '8px' }}>{shipping.Fax || '—'}</span>
        </div>
      </td>
      <td style={{ textAlign: 'center', verticalAlign: 'middle', padding: '8px' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <strong style={{ fontSize: '14px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>#Tracking :</strong>
          <input
            type="text"
            name="trackingID"
            value={trackingNumber}
            style={{
              width: '30%',

              minHeight: '20px',
              padding: '8px',
              fontSize: '13px',
              borderRadius: '15px',
              border: '1px solid rgba(236, 152, 202)',
              marginLeft: '8px',
              outline: 'none',
            }}onFocus={(e) => {
        e.target.style.border = '1px solid #ec008c';
        e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
      }}
      onBlur={(e) => {
         e.target.style.border = '1px solid rgba(236, 152, 202)';
        e.target.style.boxShadow = '0 1px 2px rgba(236, 152, 202)';
      }}
          />
        </div>
        {/* Show tracking result below input */}
        {/* {trackingResult && (
          <div style={{ color: trackingResult.success ? 'green' : 'red', marginTop: '6px', marginLeft: '180px' }}>
            {trackingResult.success ? 'Tracking found!' : trackingResult.message}
          </div>
        )} */}
      </td>
    </tr>
    <tr>
      <td style={{ textAlign: 'left', verticalAlign: 'middle', padding: '8px', borderRight: '1px solid #ec008c' }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
          <strong style={{ fontSize: '14px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Address :</strong>
          <textarea value={shipping?.Address || ''}
            readOnly
            style={{
              width: '80%',
              minHeight: '60px',
              padding: '8px',
              fontSize: '13px',
              borderRadius: '25px',
              border: '1px solid rgba(236, 152, 202)',
              resize: 'vertical',
              marginLeft: '8px',
            outline: 'none',
            }}onFocus={(e) => {
        e.target.style.border = '1px solid #ec008c';
        e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
      }}
      onBlur={(e) => {
         e.target.style.border = '1px solid rgba(236, 152, 202)';
        e.target.style.boxShadow = '0 1px 2px rgba(236, 152, 202)';
      }}
          ></textarea>
        </div>
      </td>
      <td style={{ textAlign: 'center', verticalAlign: 'middle', padding: '8px' }}>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
          <strong style={{ fontSize: '14px', color: 'Black', minWidth: '120px', display: 'inline-block' }}>Notes :</strong>
          <textarea name="trackingID"
            style={{
              width: '500px',
              minHeight: '60px',
              padding: '8px',
              fontSize: '13px',
              borderRadius: '15px',
              border: '1px solid rgba(236, 152, 202)',
              resize: 'vertical',
              marginLeft: '8px',
           outline: 'none',
            }}onFocus={(e) => {
        e.target.style.border = '1px solid #ec008c';
        e.target.style.boxShadow = '0 0 6px rgba(236, 0, 140, 0.4)';
      }}
      onBlur={(e) => {
         e.target.style.border = '1px solid rgba(236, 152, 202)';
        e.target.style.boxShadow = '0 1px 2px rgba(236, 152, 202)';
      }} placeholder='Please enter the Notes'></textarea>
        </div>
      </td>
    </tr>
  </tbody>
</table>

</div>

        {/* Prescription Grid */}
        <div style={{ width: '100%', margin: '0 auto' }}>
          <div className="sub-section-header" style={{ color: '#ec008c', fontWeight: 'bold', fontSize: '18px' }}>Prescriptions</div>
          <div style={{ height: 'auto' }}>
            {contractType === 'Premier' && memberConcernFlag === true && (
                                         <>
                                           <DataGrid
                                             rows={mainGridRowsWithSummary }
                                             columns={columns}
                                             pageSize={5}
                                             rowsPerPageOptions={[5]}
                                             hideFooter
                                             getRowClassName={(params) =>
                                               params.row.isSummary ? 'summary-row' : ''
                                             }
                                             sx={{
                                                   fontSize: '12px',
                                                   fontFamily: 'Segoe UI',
                                                   '& .pink-header': {
                                                     color: '#fff',
                                                     backgroundColor: '#ec008c',
                                                     fontWeight: 'bold',
                                                      whiteSpace: 'normal !important',
                                         wordBreak: 'breakWord !important',
                                         overflowWrap: 'breakWord !important',
                                         lineHeight: '1.3 !important',
                                         textAlign: 'center', /* Optional: center the header text */
                                         padding: '8px 2px !important',
                                                   },
                                                    '& .MuiDataGrid-row:hover': {
                                                     backgroundColor: '#f5f5f5 !important',
                                                     cursor: 'pointer',
                                                   },// Remove blue outline on cell focus
                                           '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
                                             outline: 'none !important',
                                             boxShadow: 'none !important',
                                             backgroundColor: 'none !important',  
                                            },
                                            //'& .MuiDataGrid-row:focus-within': {
                                           //   backgroundColor: '#f5bcbc !important',
                                           // },
                                           // Remove blue outline on column header focus
                                           '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
                                             outline: 'none !important',
                                             boxShadow: 'none !important',
                                           },
                                                 }}
                                           />
                                           <DataGrid
                                             rows={menopurGridRowsWithSummary }
                                             columns={columnsMenopur}
                                             pageSize={5}
                                             rowsPerPageOptions={[5]}
                                             hideFooter
                                             getRowClassName={(params) =>
                                               params.row.isSummary ? 'summary-row' : ''
                                             }
                                             sx={{
                                                   fontSize: '12px',
                                                   fontFamily: 'Segoe UI',
                                                   '& .pink-header': {
                                                     color: '#fff',
                                                     backgroundColor: '#ec008c',
                                                     fontWeight: 'bold',
                                                      whiteSpace: 'normal !important',
                                         wordBreak: 'breakWord !important',
                                         overflowWrap: 'breakWord !important',
                                         lineHeight: '1.3 !important',
                                         textAlign: 'center', /* Optional: center the header text */
                                         padding: '8px 2px !important',
                                                   },
                                                    '& .MuiDataGrid-row:hover': {
                                                     backgroundColor: '#f5f5f5 !important',
                                                     cursor: 'pointer',
                                                   },// Remove blue outline on cell focus
                                           '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
                                             outline: 'none !important',
                                             boxShadow: 'none !important',
                                             backgroundColor: 'none !important',  
                                            },
                                            //'& .MuiDataGrid-row:focus-within': {
                                           //   backgroundColor: '#f5bcbc !important',
                                           // },
                                           // Remove blue outline on column header focus
                                           '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
                                             outline: 'none !important',
                                             boxShadow: 'none !important',
                                           },
                                                 }}
                                           />
                                         </>
                                       )}
                                                             { (memberConcernFlag === false &&(<DataGrid
                                                               rows={rowsWithSummary}
                                                               columns={columns}
                                                               pageSize={5}
                                                               rowsPerPageOptions={[5]}
                                                               hideFooter
                                                               getRowClassName={(params) =>
                                                               params.row.isSummary ? 'summary-row' : ''}
                                                               sx={{
                                                   fontSize: '12px',
                                                   fontFamily: 'Segoe UI',
                                                   '& .pink-header': {
                                                     color: '#fff',
                                                     backgroundColor: '#ec008c',
                                                     fontWeight: 'bold',
                                                      whiteSpace: 'normal !important',
                                         wordBreak: 'breakWord !important',
                                         overflowWrap: 'breakWord !important',
                                         lineHeight: '1.3 !important',
                                         textAlign: 'center', /* Optional: center the header text */
                                         padding: '8px 2px !important',
                                                   },
                                                    '& .MuiDataGrid-row:hover': {
                                                     backgroundColor: '#f5f5f5 !important',
                                                     cursor: 'pointer',
                                                   },// Remove blue outline on cell focus
                                           '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
                                             outline: 'none !important',
                                             boxShadow: 'none !important',
                                             backgroundColor: 'none !important',  
                                            },
                                            //'& .MuiDataGrid-row:focus-within': {
                                           //   backgroundColor: '#f5bcbc !important',
                                           // },
                                           // Remove blue outline on column header focus
                                           '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
                                             outline: 'none !important',
                                             boxShadow: 'none !important',
                                           },
                                                 }}
                                                             />))}
          </div>

         {(contract === 'HMO Illinois' 
        || contract === 'Chewy-Aetna-Premier' || contract === 'WINFertilityRx' || 
            contract === 'WINFertility Genetics' || contract === 'WINFertility DTC' )&& (
          <div style={{ textAlign: 'right', fontWeight: 'bold', marginTop: '10px', marginBottom: '20px' }}>
            Total Amount: ${totalAmount}
          </div>)}
          {((taskDetail?.ContractType?.trim() === 'Premier' || taskDetail.ContractType?.trim() === 'Premier')
          && contract !== 'Chewy-Aetna-Premier') && (
            // <>
            //   <div style={{ marginLeft: '20px', color: '#000' }}>
            //     Member Cost Share: ${TotalMemberPays}
            //   </div>
            //   <div style={{ marginLeft: '20px', color: '#000' }}>
            //     WIN To Pharmacy: ${totalWinPays}
            //   </div>
            // </>
             <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', marginRight: '20px', color: '#000' }}>
  <div style={{ marginBottom: '4px' }}>
    Member Cost Share: ${parseFloat(TotalMemberPays).toFixed(2)}
  </div>
  <div>
    WIN To Pharmacy: ${parseFloat(Math.max(0, totalWinPays)).toFixed(2)}
  </div>
  {memberConcernFlag === true && (
    <div>
    WINCard Value: ${parseFloat(winCardAmount).toFixed(2)}
  </div>
  )}
</div>
          )}

          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '5px' }}>
            <button className="button-open-order" onClick={() => navigate('/paid-claims')}>Back</button>
          </div>
        </div>

        </div>
      </div>
    </>
  );
};

export default PaidTaskOpenOrders;
